import { useCallback, useEffect, useState } from 'react';

import { Player } from '../../../types';

type TapToUnmuteProps = {
  player: Player | null;
  autoplay: boolean;
  hideUnmute: boolean;
};

const HAS_AUDIO_DETECT_DELAY = 200;

let timer: number;

const useTapToUnmute = ({ player, autoplay, hideUnmute }: TapToUnmuteProps) => {
  const [showTapIcon, setShowTapIcon] = useState(false);
  const [hasAudio, setHasAudio] = useState<boolean>();

  const handleUnmuteClick = useCallback(() => {
    if (!player) return;

    player.muted = false;
    setShowTapIcon(false);
  }, [player]);

  const onPlaying = useCallback(() => {
    if (!player) return;

    timer = window.setTimeout(() => setHasAudio(player.hasAudio), HAS_AUDIO_DETECT_DELAY);

    return () => clearInterval(timer);
  }, [player]);

  useEffect(() => {
    if (!player || !autoplay) return;

    const canShowIcon = player.muted && hasAudio && !hideUnmute;

    canShowIcon && setShowTapIcon(true);
  }, [hasAudio, autoplay]);

  useEffect(() => {
    if (!player) return;

    player.on('playing', onPlaying);

    return () => player.off('playing', onPlaying);
  }, [player]);

  return [showTapIcon, handleUnmuteClick] as const;
};

export default useTapToUnmute;
